module.exports = __webpack_public_path__ + "static/map-66d83b84758815eb79e1bfd8acfc5299.png";